/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCoolingRegimeTemperatureDtoFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeCoolingRegimeTemperatureDto, serializeUpsertCommand, type CoolingRegimeTemperatureDto, type ProblemDetails, type UpsertCommand, type ValidationProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { CoolingRegimeTemperaturesItemRequestBuilderRequestsMetadata, type CoolingRegimeTemperaturesItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/CoolingRegimeTemperatures
 */
export interface CoolingRegimeTemperaturesRequestBuilder extends BaseRequestBuilder<CoolingRegimeTemperaturesRequestBuilder> {
    /**
     * Gets an item from the Kiota.TypeScript.Api.api.vWithVersion.CoolingRegimeTemperatures.item collection
     * @param id The identifier.
     * @returns {CoolingRegimeTemperaturesItemRequestBuilder}
     */
     byId(id: number) : CoolingRegimeTemperaturesItemRequestBuilder;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 32767, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeTemperatureDto[]>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     get(requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesRequestBuilderGetQueryParameters> | undefined) : Promise<CoolingRegimeTemperatureDto[] | undefined>;
    /**
     * @param body Class UpsertCommand.Implements the CoolingRegimeGenusDto            
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeTemperatureDto>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 429 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     post(body: UpsertCommand, requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesRequestBuilderPostQueryParameters> | undefined) : Promise<CoolingRegimeTemperatureDto | undefined>;
    /**
     * Query settings:MaxExpansionDepth = 0, MaxSkip = 32767, MaxTop = 1000, PageSize = 1000
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body Class UpsertCommand.Implements the CoolingRegimeGenusDto            
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: UpsertCommand, requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * Query settings:MaxExpansionDepth = 0, MaxSkip = 32767, MaxTop = 1000, PageSize = 1000
 */
export interface CoolingRegimeTemperaturesRequestBuilderGetQueryParameters {
    /**
     * Filter the results using OData syntax.
     */
    filter?: string;
    /**
     * Order the results using OData syntax.
     */
    orderby?: string;
    /**
     * Skip the number of results returned.
     */
    skip?: number;
    /**
     * Limit the number of results returned.
     */
    top?: number;
}
export interface CoolingRegimeTemperaturesRequestBuilderPostQueryParameters {
    culture?: string;
}
/**
 * Uri template for the request builder.
 */
export const CoolingRegimeTemperaturesRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/CoolingRegimeTemperatures{?%24filter*,%24orderby*,%24skip*,%24top*,culture*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const CoolingRegimeTemperaturesRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "filter": "%24filter",
    "orderby": "%24orderby",
    "skip": "%24skip",
    "top": "%24top",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CoolingRegimeTemperaturesRequestBuilderNavigationMetadata: Record<Exclude<keyof CoolingRegimeTemperaturesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: CoolingRegimeTemperaturesItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CoolingRegimeTemperaturesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CoolingRegimeTemperaturesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCoolingRegimeTemperatureDtoFromDiscriminatorValue,
        queryParametersMapper: CoolingRegimeTemperaturesRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: CoolingRegimeTemperaturesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCoolingRegimeTemperatureDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpsertCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
